import http, { podcastGeneratioonInstance } from './http'
export const generateConversation = (payload) => {
    return http({
        method: 'POST',
        data: payload,
        url: `/podcastai/content`
    })
}
export const generatePodcastAudio = (payload) => {
    return http({
        method: 'POST',
        data: payload,
        url: `/podcastai/tts`
    })
}
export const createVoice = (payload) => {
    return http({
        method: 'POST',
        data: payload,
        url: `/podcastai/voices`
    })
}
export const deleteVoice = (payload) => {
    return http({
        method: 'DELETE',
        data: payload,
        url: `/podcastai/voices`
    })
}
export const getAllVoices = () => {
    return http({
        method: 'GET',
        url: `/podcastai/voices`
    })
}
export const newPodcastGenerate = async (payload, onChunk, onFinish) => {
    const url = process.env.REACT_APP_PODCAST_SERVICE;
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "text/event-stream",
        },
        body: JSON.stringify(payload),
    });

    if (!response.ok || !response.body) {
        throw new Error("Failed to connect or stream not supported.");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");

    let buffer = "";
    let textPart = "";
    let jsonPart = "";
    let jsonStarted = false;
    let totalStreamedLength = 0; // Track total length of all content we've processed

    const CHUNK_SIZE = 50; // Much smaller chunk size for immediate response
    const DELAY = 0; // No delay for instant streaming

    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    // Function to find good breaking points (word boundaries)
    const findWordBoundary = (text, startPos, maxLength) => {
        if (startPos + maxLength >= text.length) {
            return text.length;
        }

        const endPos = startPos + maxLength;
        // Look backwards from endPos to find a space
        for (let i = endPos; i > startPos; i--) {
            if (text[i] === ' ' || text[i] === '\n' || text[i] === '\t') {
                return i + 1; // Include the space
            }
        }

        // If no space found, look forward
        for (let i = endPos; i < text.length; i++) {
            if (text[i] === ' ' || text[i] === '\n' || text[i] === '\t') {
                return i + 1;
            }
        }

        // Fallback to character boundary if no word boundary found
        return endPos;
    };

    // Only stream new content
    const streamTextChunks = async (newContent) => {
        let pos = 0;
        while (pos < newContent.length) {
            const nextPos = findWordBoundary(newContent, pos, CHUNK_SIZE);
            const chunk = newContent.slice(pos, nextPos);
            if (chunk && onChunk) {
                onChunk(chunk);
            }
            pos = nextPos;
            // No delay for immediate response
        }
    };

    while (true) {
        const { value, done } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        buffer += chunk;

        if (!jsonStarted) {
            const delimiter = "<<END>>";
            const index = buffer.indexOf(delimiter);

            if (index !== -1) {
                const preJson = buffer.slice(0, index);
                buffer = buffer.slice(index + delimiter.length);
                jsonStarted = true;

                // Only stream content we haven't streamed yet
                const newContent = preJson.slice(totalStreamedLength);
                if (newContent) {
                    await streamTextChunks(newContent);
                    textPart += newContent;
                    totalStreamedLength = preJson.length; // Update to total processed length
                }

                jsonPart += buffer;
                buffer = "";
            } else {
                // Check if we have enough safe content to stream
                const safeLength = Math.max(0, buffer.length - delimiter.length);
                if (safeLength > totalStreamedLength) {
                    const newContent = buffer.slice(totalStreamedLength, safeLength);
                    if (newContent) {
                        await streamTextChunks(newContent);
                        textPart += newContent;
                        totalStreamedLength = safeLength; // Update to safe length
                    }
                }
            }
        } else {
            jsonPart += buffer;
            buffer = "";
        }
    }

    let parsedJson = {};
    try {
        parsedJson = JSON.parse(jsonPart);
    } catch (err) {
        console.error("JSON parse failed:", err);
    }

    if (onFinish) {
        onFinish({
            fullText: textPart,
            json: parsedJson,
        });
    }

    return {
        fullText: textPart,
        jsonPart: parsedJson,
    };
};

export const getAllMusic = () => {
    return http({
        method: 'GET',
        url: `/library?isMusic=true`
    })
}

export const checkPodcastStatus = (id) => {
    return http({
        method: 'GET',
        url: `library/${id}/info`
    })
}

export const chatPodcastGenerate = async (payload, onChunk, onFinish) => {
    const url = process.env.REACT_APP_PODCAST_SERVICE;
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "text/event-stream",
        },
        body: JSON.stringify(payload),
    });

    if (!response.ok || !response.body) {
        throw new Error("Failed to connect or stream not supported.");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");

    let buffer = "";
    let textPart = "";
    let jsonPart = "";
    let jsonStarted = false;
    let totalStreamedLength = 0;

    const CHUNK_SIZE = 50;
    const DELAY = 0;

    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const findWordBoundary = (text, startPos, maxLength) => {
        if (startPos + maxLength >= text.length) {
            return text.length;
        }

        const endPos = startPos + maxLength;
        for (let i = endPos; i > startPos; i--) {
            if (text[i] === ' ' || text[i] === '\n' || text[i] === '\t') {
                return i + 1;
            }
        }

        for (let i = endPos; i < text.length; i++) {
            if (text[i] === ' ' || text[i] === '\n' || text[i] === '\t') {
                return i + 1;
            }
        }

        return endPos;
    };

    const streamTextChunks = async (newContent) => {
        let pos = 0;
        while (pos < newContent.length) {
            const nextPos = findWordBoundary(newContent, pos, CHUNK_SIZE);
            const chunk = newContent.slice(pos, nextPos);
            if (chunk && onChunk) {
                onChunk(chunk);
            }
            pos = nextPos;
        }
    };

    while (true) {
        const { value, done } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        buffer += chunk;

        if (!jsonStarted) {
            const delimiter = "<<END>>";
            const index = buffer.indexOf(delimiter);

            if (index !== -1) {
                const preJson = buffer.slice(0, index);
                buffer = buffer.slice(index + delimiter.length);
                jsonStarted = true;

                const newContent = preJson.slice(totalStreamedLength);
                if (newContent) {
                    await streamTextChunks(newContent);
                    textPart += newContent;
                    totalStreamedLength = preJson.length;
                }

                jsonPart += buffer;
                buffer = "";
            } else {
                const safeLength = Math.max(0, buffer.length - delimiter.length);
                if (safeLength > totalStreamedLength) {
                    const newContent = buffer.slice(totalStreamedLength, safeLength);
                    if (newContent) {
                        await streamTextChunks(newContent);
                        textPart += newContent;
                        totalStreamedLength = safeLength;
                    }
                }
            }
        } else {
            jsonPart += buffer;
            buffer = "";
        }
    }

    let parsedJson = {};
    try {
        parsedJson = JSON.parse(jsonPart);
    } catch (err) {
        console.error("JSON parse failed:", err);
    }

    if (onFinish) {
        onFinish({
            fullText: textPart,
            json: parsedJson,
        });
    }

    return {
        fullText: textPart,
        jsonPart: parsedJson,
    };
};